import { useCallback, useEffect, useMemo, useState } from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router';

const useQueryParams = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  );

  const getQueryParam = useCallback(key => queryParams?.[key], [queryParams]);

  const useQueryParam = key => {
    const [queryParam, setQueryParam] = useState(undefined);
    useEffect(() => {
      setQueryParam(queryParams[key]);
    }, [queryParams[key]]);

    return queryParam;
  };

  const updateQueryParam = useCallback(
    (key, value) => {
      const searchParams = queryString.parse(location.search);

      if (value) {
        searchParams[key] = value;
      } else {
        delete searchParams[key];
      }

      history.push({
        ...location,
        search: queryString.stringify(searchParams)
      });
    },
    [location]
  );

  const updateQuery = useCallback(
    (query = {}) => {
      // query { [key: string]: value: string }
      if (Object.keys(query).length === 0) return;

      const searchParams = queryString.parse(location.search);

      Object.entries(query).forEach(([key, value]) => {
        if (value) {
          if (typeof value === 'string') {
            searchParams[key] = value;
          }
        } else {
          delete searchParams[key];
        }
      });

      history.push({
        ...location,
        search: queryString.stringify(searchParams)
      });
    },
    [location]
  );

  return {
    queryParams,
    getQueryParam,
    updateQueryParam,
    updateQuery,
    useQueryParam
  };
};

export default useQueryParams;
